import React, { useState, useEffect, useRef } from 'react';
import { Button } from './ui/button';
import { Shield, Zap, X } from 'lucide-react';

const StickyCTA = ({ onEnroll, isEnrolled }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past hero section (about 600px)
      const shouldShow = window.scrollY > 600;
      setIsVisible(shouldShow && !isDismissed);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isDismissed]);

  if (!isVisible || isEnrolled) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 transform transition-transform duration-300 ease-out"
      style={{ transform: isVisible ? 'translateY(0)' : 'translateY(100%)' }}
    >
      <div className="bg-gradient-to-r from-slate-900 to-slate-800 border-t border-slate-700 shadow-2xl">
        <div className="container mx-auto px-4 py-3">
          <div className="flex items-center justify-between gap-4">
            {/* Left content */}
            <div className="flex items-center gap-3">
              <div className="hidden sm:flex w-10 h-10 rounded-lg bg-emerald-500/20 items-center justify-center">
                <Shield className="w-5 h-5 text-emerald-400" />
              </div>
              <div>
                <p className="text-white font-semibold text-sm sm:text-base">
                  Start Your Free OSHA Training
                </p>
                <p className="text-slate-400 text-xs sm:text-sm hidden sm:block">
                  Join 8,500+ safety professionals • Certificate included
                </p>
              </div>
            </div>

            {/* Right content */}
            <div className="flex items-center gap-2">
              <Button
                onClick={onEnroll}
                className="bg-emerald-500 hover:bg-emerald-600 text-white px-4 sm:px-6 py-2 text-sm font-medium whitespace-nowrap"
              >
                <Zap className="w-4 h-4 mr-1 sm:mr-2" />
                <span className="hidden sm:inline">Enroll Free</span>
                <span className="sm:hidden">Start</span>
              </Button>
              <button
                onClick={() => setIsDismissed(true)}
                className="p-2 text-slate-400 hover:text-white transition-colors"
                aria-label="Dismiss"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StickyCTA;
